import { v4 as uuidv4 } from 'uuid';

import { NOTIFY_ERROR } from '../constants/actionTypes';

const { REACT_APP_ENV: RELEASE_STAGE } = process.env;
export const initialState = [];

const errors = (state = initialState, action) => {
  const { type } = action;
  const newState = state.slice(0);
  if (type === NOTIFY_ERROR) {
    const { error } = action;

    if (RELEASE_STAGE.includes('development')) {
      console.error(error); // eslint-disable-line
    }

    newState.push({
      id: uuidv4(),
      error,
    });
  }

  return newState || state;
};

export default errors;
